import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getSelectedCatalogItems } from 'entities/CatalogItem/model/selectors/catalogItemSelectors';
import { useCatalogIdentity } from 'shared/lib/contexts/CatalogIdentityContext';

import {
    emptyListOrderCoverage,
    getListOrderCoverage,
} from './getListOrderCoverage';

import type { ListOrderCoverage } from './getListOrderCoverage';
import type { CustomListDetail } from 'entities/CustomList';

export const useListOrderCoverage = (
    listId: string | undefined,
    detail: CustomListDetail | null | undefined,
): ListOrderCoverage => {
    const selectedItems = useSelector(getSelectedCatalogItems);
    const identity = useCatalogIdentity();

    return useMemo(() => {
        if (!detail || detail.id !== listId) {
            return emptyListOrderCoverage();
        }

        return getListOrderCoverage(
            detail.items || [],
            selectedItems,
            identity,
        );
    }, [detail, identity, listId, selectedItems]);
};
